import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

jQuery(document).ready(function ($) {
    let slidesCount = $('.partners-swiper .partners__item').length;
    let maxSlides = 5;
    let maxSlidesMid = 4;

    if (slidesCount < 5) {
        maxSlides = slidesCount;
    }
    if (slidesCount < 4) {
        maxSlidesMid = slidesCount;
    }
    const partnersSwiper = new Swiper('.partners-swiper', {
        // Optional parameters
        //loop: true,
        spaceBetween: 41,
        slidesPerView: 1,
        observer: true,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1096: {
                slidesPerView: maxSlidesMid,
            },
            1680: {
                slidesPerView: maxSlides,
            },
        },
        navigation: {
            nextEl: '.partners-swiper__next',
            prevEl: '.partners-swiper__prev',
        },
    });

});